import { Injectable, Injector } from '@angular/core';
import { ApiCallHandler, IHttpParams, STATUS } from 'ngx-eo-web-components';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  static injector: Injector;

  private subscriptions: Subscription[] = [];

  // private token$ = this.authService.token$;

  roles: string[] = [];
  useremail: string = '';

  constructor(
    private injector: Injector,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    CoreService.injector = this.injector;
    // this.subscriptions = [
    //   this.token$.subscribe((t) => {
    //     this.roles = t?.role?.split(',') ?? [];
    //     this.useremail = t?.email ?? '';
    //   }),
    // ];
    //this.authService.TokenExpirationCheck();
  }

  hasRoles(userRoles: string[]) {
    return userRoles.some((r) => this.roles.includes(r));
  }

  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any
  ): IHttpParams;
  public initCall<T>(
    apiPath: string,
    apiCallHandler: ApiCallHandler<T>,
    requestBody?: any
  ): IHttpParams {
    // apiCallHandler.status$.next(STATUS.loading);
    // apiCallHandler.error$.next(null);
    let result = {
      ...{
        url: `${environment.apiUrl}${apiPath}`,
        success$: apiCallHandler.data$,
        status$: apiCallHandler.status$,
        error$: apiCallHandler.error$,
      },
      ...(requestBody != undefined && { body: requestBody }),
    };

    return result;
  }

  successCall<T>(data: T, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.data$.next(data);
    apiCallHandler.status$.next(STATUS.success);
  }

  errorCall<T>(errorMessage: string, apiCallHandler: ApiCallHandler<T>) {
    apiCallHandler.error$.next(errorMessage);
    apiCallHandler.status$.next(STATUS.error);
  }

  downLoadFile(data: any, type: string, filename: string) {
    let blob = new Blob([data], { type: type });
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  downLoadExcelFile(data: any, filename: string) {
    this.downLoadFile(
      data,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      filename
    );
  }

  showError(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Παρουσιάστηκε σφάλμα',
      detail: message,
    });
  }

  showSuccess(message: string, title: string = 'Επιτυχής ενέργεια') {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: message,
    });
  }

  confirmDialog(options: Confirmation) {
    this.confirmationService.confirm({
      key: 'def',
      header: 'Είστε σίγουροι;',
      message: `Είστε σίγουροι ότι θέλετε να προχωρήσετε;`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Εντάξει',
      acceptIcon: '-',
      rejectLabel: 'Άκυρο',
      rejectButtonStyleClass: 'p-button-outlined',
      rejectIcon: '-',
      ...options,
    });
  }

  exportExcelConfirmDialog(options: Confirmation) {
    this.confirmDialog({
      header: 'Δημιουργία αρχείου Excel',
      message: `Μόλις ολοκληρωθεί η δημιουργία του excel αρχείου θα λάβετε ηλεκτρονικό μήνυμα στο email σας.`,
      acceptLabel: 'Δημιουργία',
      ...options,
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((s) => s.unsubscribe);
  }

  confirm(confirmation: Confirmation) {
    this.confirmationService.confirm({
      ...confirmation,
      key: 'def',
      header: confirmation.header ?? ' ',
      icon: confirmation.icon ?? 'pi pi-info-circle',
      rejectButtonStyleClass:
        confirmation.rejectButtonStyleClass ?? 'p-button-outlined',
      acceptLabel: confirmation.acceptLabel ?? 'Ναί',
      rejectLabel: confirmation.rejectLabel ?? 'Άκυρο',
      acceptIcon: confirmation.acceptIcon ?? '-',
      rejectIcon: confirmation.rejectIcon ?? '-',
    });
  }
}
